'use strict';

import {gaamendmentChecklistModel} from "../../models/gaamendmentchecklistmodel.js";
import {projectChangeModel} from "../../models/projectchangemodel.js";

export class GAchecklistsCtrl
{
	changeData = {};
//
	constructor($scope, $filter, $timeout, $mdDialog, jsDataService, notify){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.notify = notify;
		this.$mdDialog = $mdDialog;
		this.$timeout = $timeout;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.changeData = new projectChangeModel(jsDataService.get('changeData', {}), $filter, jsDataService);

		if (this.changeData.coordinator && this.changeData.coordinator.time > 0) {
			this.changeData.coordinator.time = new Date(this.changeData.coordinator.time * 1000);
		}

		if (this.changeData.lawyer && this.changeData.lawyer.time > 0) {
			this.changeData.lawyer.time = new Date(this.changeData.lawyer.time * 1000);
		}
		if (this.changeData.manager && this.changeData.manager.time > 0) {
			this.changeData.manager.time = new Date(this.changeData.manager.time * 1000);
		}

		this.postConstruct();
	}

	postConstruct(){
		let evaluation = this.jsDataService.get('evaluation', {});
		this.evaluation = new gaamendmentChecklistModel(evaluation, this.$filter, this.jsDataService);
	}

	getQuestions(){
		return this.evaluation.data_value.questions;
	}

	autosavePostFields() {
		const dv = this.evaluation.data_value;
		const cd = dv.coordinatorData || {};
		const lwD = dv.lawyerData       || {};
		const tlD = dv.teamLeadData     || {};

		return {
			questions:           dv.questions,
			number:              dv.GAnumber,

			coordinatorData:     { name: cd.name   || '' },
			coordinatorApproved: dv.coordinatorApproved  || false,
			coordinatorComment:  dv.coordinatorComment   || '',

			lawyerData:          { name: lwD.name  || '' },
			lawyerApproved:      dv.lawyerApproved        || false,
			lawyerComment:       dv.lawyerComment         || '',

			teamLeadData:        { name: tlD.name  || '' },
			teamLeadApproved:    dv.teamLeadApproved      || false,
			teamLeadComment:     dv.teamLeadComment       || ''
		};
	}



	confirmEvaluation(ev){
        this.$mdDialog.show({
            controller: ["$scope", "$mdDialog", this.completeDialogCtrl],
            templateUrl: 'projects/gachecklist_coordinator_submit.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
//				locals: {
//					evaluation: this.evaluation
//				}
        }).then((results) => {
            const url = this.jsDataService.get('cfgSubmitUrl');
            if (url) {
                this.$scope.basicHttpConfigProcess({
                    url: url,
                    method: 'POST',
                    data: results
                });
            }
        }, () => {
        });

	}

	lawyerEvaluation(ev) {
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", this.completeDialogCtrl],
			templateUrl: 'projects/gachecklist_submit.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
//				locals: {
//					evaluation: this.evaluation
//				}
		}).then((results) => {
			const url = this.jsDataService.get('cfgLawyerActionUrl');
			if (url) {
				this.$scope.basicHttpConfigProcess({
					url: url,
					method: 'POST',
					data: results
				});
			}
		}, () => {
		});

	}

	managerEvaluation(ev) {
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", this.completeDialogCtrl],
			templateUrl: 'projects/gachecklist_submit.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
//				locals: {
//					evaluation: this.evaluation
//				}
		}).then((results) => {
			const url = this.jsDataService.get('cfgManagerActionUrl');
			if (url) {
				this.$scope.basicHttpConfigProcess({
					url: url,
					method: 'POST',
					data: results
				});
			}
		}, () => {
		});

	}

	completeDialogCtrl($scope, $mdDialog) {
		$scope.comment = '';
		$scope.action;
		$scope.close = function () {
			$mdDialog.cancel();
		};

		$scope.approve = function () {
			$scope.action = 'approve';
			$scope.submitDialog();
		};

		$scope.disapprove = function () {
			$scope.action = 'disapprove';
			$scope.submitDialog();
		};

		$scope.return = function () {
			$scope.action = 'return';
			$scope.submitDialog();
		};

		$scope.submitDialog = function () {
			if (typeof ($scope.action) !== 'undefined' && $scope.action !== '') {
				$mdDialog.hide({
					action: $scope.action,
					comment: $scope.comment
				});
			} else {
				console.log('Undefined action');
			}
		};
	}

//	cancelEvaluation(ev){
//		this.$mdDialog.show({
//			controller: ["$scope", "$mdDialog", this.completeDialogCtrl],
//			templateUrl: 'contracts/evaluation_return.html',
//			parent: angular.element(document.body),
//			targetEvent: ev,
//			clickOutsideToClose: false,
//			fullscreen: true
////				locals: {
////					evaluation: this.evaluation
////				}
//		}).then((results) => {
//			const url = this.jsDataService.get('cfgCancelUrl');
//			if (url) {
//				this.$scope.basicHttpConfigProcess({
//					url: url,
//					method: 'POST',
//					data: results
//				});
//			}
//		}, () => {
//		});
//
//	}
	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}
}